export const TIMELINE_CONTEXT_ACTION_TYPES = {
  SET_EXPANDED_IDS: 'set-expanded-ids',
  SET_HOVER_DATA: 'set-hover-data',
  SET_HOVERED_PHASE_KEY: 'set-hovered-phase-key',
  SET_ACTIVE_PHASE_KEY: 'set-active-phase-key',
  SET_WEEK_CONTAINER_WIDTH: 'set-week-container-width',
  SET_GROUP_STRATEGY: 'set-group-strategy',
  SET_SORT_STRATEGY: 'set-sort-strategy',
  SET_CONTAINER_WIDTH: 'set-container-width',
  SET_VIEW_STRATEGY: 'set-view-strategy',
  SET_HOVERED_TASK_KEY: 'set-hovered-task-key',
  SET_ACTIVE_TASK_KEY: 'set-active-task-key',
  SET_SHOW_SUCCESSIONS: 'set-show-successions',
  SET_EXPANDED_SUCCESSION_KEY: 'set-expanded-succession-key',
  SET_HOVERED_REPORT_INDEX: 'set-hovered-report-index',
  SET_SHOW_ORG_TASKS: 'set-show-org-tasks',
}

export const initialState = {
  expandedIds: [],
  hoverData: { x: 0, dateStr: '', show: false },
  hoveredPhaseKey: null,
  activePhaseKey: null,
  weekContainerWidth: null,
  groupStrategy: 'none',
  sortStrategy: 'alphabetical',
  containerWidth: 0,
  viewStrategy: 'phases',  // 'phases' | 'tasks' | 'both'
  hoveredTaskKey: null,
  activeTaskKey: null,
  showSuccessions: false,
  expandedSuccessionKey: null,  // format: `${cropId}-${successionIndex}` (1-based)
  showOrgTasks: true,
  hoveredReportIndex: null,
}

export function TimelineContextReducer(state, action) {
  switch(action.type) {
    case TIMELINE_CONTEXT_ACTION_TYPES.SET_EXPANDED_IDS:
      return {
        ...state,
        expandedIds: action.expandedIds
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_HOVER_DATA:
      return {
        ...state,
        hoverData: action.hoverData
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_HOVERED_PHASE_KEY:
      return {
        ...state,
        hoveredPhaseKey: action.hoveredPhaseKey
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_ACTIVE_PHASE_KEY:
      return {
        ...state,
        activePhaseKey: action.activePhaseKey
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_WEEK_CONTAINER_WIDTH:
      return {
        ...state,
        weekContainerWidth: action.weekContainerWidth
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_GROUP_STRATEGY:
      return {
        ...state,
        groupStrategy: action.groupStrategy
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_SORT_STRATEGY:
      return {
        ...state,
        sortStrategy: action.sortStrategy
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_CONTAINER_WIDTH:
      return {
        ...state,
        containerWidth: action.containerWidth
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_VIEW_STRATEGY:
      return {
        ...state,
        viewStrategy: action.viewStrategy
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_HOVERED_TASK_KEY:
      return {
        ...state,
        hoveredTaskKey: action.hoveredTaskKey
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_ACTIVE_TASK_KEY:
      return {
        ...state,
        activeTaskKey: action.activeTaskKey
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_SHOW_SUCCESSIONS:
      return {
        ...state,
        showSuccessions: action.showSuccessions
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_EXPANDED_SUCCESSION_KEY:
      return {
        ...state,
        expandedSuccessionKey: action.expandedSuccessionKey
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_HOVERED_REPORT_INDEX:
      return {
        ...state,
        hoveredReportIndex: action.hoveredReportIndex
      }

    case TIMELINE_CONTEXT_ACTION_TYPES.SET_SHOW_ORG_TASKS:
      return {
        ...state,
        showOrgTasks: action.showOrgTasks
      }

    default: {
      throw new Error('Unknown action sent to TimelineContextReducer:', action.type)
    }
  }
}
